import {useContext, useMemo} from 'react';
import {IMAGE_FILTERS} from '~/CreateFabricInvitation/hooks/useImageFilter';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {FilterPreview} from './FilterPreview/FilterPreview';

interface Canvas {
  // biome-ignore lint/suspicious/noExplicitAny: fix any usage
  getActiveObject: () => any;
}

let unmodifiedActiveObjectSrc = '';

export const ImageFilters = () => {
  const {canvas}: {canvas: Canvas | null} = useContext(EventCreateContext);

  const activeObject = (canvas as unknown as Canvas)?.getActiveObject();
  const activeObjectSrc = useMemo(() => {
    if (!activeObject?.filter?.length) {
      unmodifiedActiveObjectSrc =
        activeObject?.canvas?._activeObject?._originalElement?.src ||
        activeObject?.canvas?._activeObject?.src ||
        activeObject?.canvas?._activeObject?.srcUrl;
      return unmodifiedActiveObjectSrc;
    }

    return unmodifiedActiveObjectSrc;
  }, [activeObject]);

  const photoPreview = useMemo(
    () =>
      Object.entries(IMAGE_FILTERS).map(([key, value]) => ({
        id: crypto.randomUUID(),
        src: activeObjectSrc as string,
        label: value.label,
        filterKey: key,
        cssFilter: value.cssFilter,
      })),
    [activeObjectSrc]
  );

  return <FilterPreview photos={photoPreview} key={crypto.randomUUID()} />;
};
